import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { OPPORTUNITIES_STATUS } from '../../opportunities/components/helpers/opportunitiesListHelper';
import FormInput from '../../../commonComponents/forms/FormInput';
import OrderProp from '../propTypes/orderProp';
import translate from '../../../commonComponents/translate';

const AVAILABLE_STATUSES = [
  OPPORTUNITIES_STATUS.QUALIFICATION,
  OPPORTUNITIES_STATUS.REFERENCES,
  OPPORTUNITIES_STATUS.LEADS,
  OPPORTUNITIES_STATUS.PROPOSAL,
  OPPORTUNITIES_STATUS.PENDING,
  OPPORTUNITIES_STATUS.COMMERCIAL_VERIFICATION,
  OPPORTUNITIES_STATUS.APPROVED,
  OPPORTUNITIES_STATUS.REJECTED,
];

function UpdateStatusContainer(props) {
  const { t, order, isLoading, onSave } = props;
  const [currentStatus, setCurrentStatus] = useState(order?.status);

  // define items for selector
  const statusItems = useMemo(
    () =>
      AVAILABLE_STATUSES.map(stat => {
        let text;
        switch (stat) {
          case OPPORTUNITIES_STATUS.REJECTED:
            text = t('status.opportunity_rejected');
            break;
          case OPPORTUNITIES_STATUS.PENDING:
            text = t('status.negotiation');
            break;
          default:
            text = t(`status.${stat}`);
            break;
        }

        return {
          id: stat,
          text,
        };
      }),
    [t],
  );

  const handleStatusChange = useCallback(
    status => setCurrentStatus(status),
    [setCurrentStatus],
  );

  const handleSave = useCallback(() => {
    onSave({ status: currentStatus });
  }, [onSave, currentStatus]);

  const isDisabled = useMemo(
    () =>
      isLoading ||
      !AVAILABLE_STATUSES.find(s => s === currentStatus) || // if it's not on the allowed status
      currentStatus === order?.status, // initial status
    [order?.status, currentStatus, isLoading],
  );
  return (
    <div className="m-portlet order-change-section">
      <h5 className="updateOrder-header">{t('update.status')}</h5>
      <FormInput
        id="order-status"
        name="order-status"
        value={currentStatus}
        type="select2"
        className="form-control"
        placeholder={t('update.status')}
        onChange={handleStatusChange}
        inputProps={{
          items: statusItems,
          searchable: true,
          multiple: false,
        }}
      />
      <div className="save-order-wrapper">
        <button
          type="button"
          onClick={handleSave}
          className={`btn m-btn--pill btn-dynamic save-order-btn ${
            isLoading ? ' m-loader m-loader--right m-loader--light' : ''
          }`}
          disabled={isDisabled}
        >
          {t('save_btn')}
        </button>
      </div>
    </div>
  );
}

UpdateStatusContainer.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isLoading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
};

UpdateStatusContainer.defaultProps = {
  isLoading: false,
};

export default translate(UpdateStatusContainer);
